import React, { Component, useState, useEffect } from "react"

import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import FloatingLabelInput from "./FloatingLabelInput"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import { Multiselect } from "multiselect-react-dropdown"
import Moment from "moment"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import ReactExport from "react-data-export"
import Select from "react-select"
import InstalmentConditoin from "./InstalmentConditoin"
import Fab from "@material-ui/core/Fab"
import AddIcon from "@material-ui/icons/Add"
import DeleteIcon from "@material-ui/icons/Delete"
import NumberFormat from "react-number-format"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
   multiselectContainer: {
      // To change css for multiselect (Width,height,etc..)
      fontSize: "14px",
      border: "1.25px solid #bababa",
      borderRadius: "4px",
   },
   searchBox: {
      // To change search box element look
      fontSize: "14px",
      minheight: "50px",
      textAlign: "right",
   },
   inputField: {
      // To change input field position or margin
      margin: "5px",
      fontSize: "14px",
   },
   chips: {
      // To change css chips(Selected options)
      //  background: '#00000000',
      border: "2px solid",
      fontSize: "14px",
   },
   optionContainer: {
      // To change css for option container
      textAlign: "right",
   },
   option: {
      // To change css for dropdown options
      fontSize: "14px",
      textAlign: "right",
   },
   groupHeading: {
      // To chanage group heading style
   },
}
const styles = (theme) => ({
   paperrtl: {
      marginTop: theme.spacing(0),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
   },
   paper: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
         margin: theme.spacing(1),
         width: theme.spacing(20),
      },
   },
   root: {
      width: "100%",
      margin: "15px",
      padding: "8px",
      direction: "rtl",
   },
   container: {
      maxHeight: 400,
   },
   select: {
      searchBox: {
         // To change search box element look
         border: "none",
         fontSize: "35px",
         minheight: "50px",
      },
      inputField: {
         // To change input field position or margin
         margin: "5px",
      },
      chips: {
         // To change css chips(Selected options)
         background: "red",
      },
      optionContainer: {
         // To change css for option container
         border: "2px solid",
      },
      option: {
         // To change css for dropdown options
         color: "blue",
      },
   },
})

class ChangeSmsManage extends Component {
   cookies = new Cookies()

   constructor(props) {
      super(props)
      this.state = {
         redirect: false,
         errstr: "",
         errstatus: false,
         okstatus: false,
         requestinfos: [],
         requestinfofilter: [],
         rowsPerPage: 10,
         page: 0,
         orderBy: "sms_rahyab_id",
         order: "desc",
         options: [],
         selectedDayDeliveryEnd: "",
         selectedDayDeliveryStart: "",
         selectedDayEnd: "",
         selectedDayStart: "",
         dataChart: [],
         priceDetail: [],
         smsStatus: "",
         mobileUsertFilter: "",
      }
   }

   componentDidMount() {
      if (this.cookies.get("employee_token_str")) {
         this.props.props.dispatch({
            type: "WAITSHOW",
         })

         var self = this
         var xhttp = new XMLHttpRequest()
         xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
               var arr = JSON.parse(this.responseText)
               if (arr.result === "ok") {
                  self.getOrder()
                  console.log("fdsfsdfsdf")
               } else if (arr.result === "error") {
                  self.setState({ redirect: true })
               }
               self.props.props.dispatch({
                  type: "WITEHIDE",
               })
            }
         }
         var fd = new FormData()
         fd.append("command", "checkemployeelogin")

         xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
         xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
         xhttp.send(fd)
      } else {
         this.setState({ redirect: true })
      }
   }

   getOrder = () => {
      const { selectedDayDeliveryEnd, selectedDayDeliveryStart, selectedDayEnd, selectedDayStart, mobileUsertFilter, smsStatus, rowsPerPage, page } =
         this.state
      var timeStampStart = ""
      var timeStampEnd = ""
      if (selectedDayStart !== "") {
         timeStampStart = Moment(JDate.toGregorian(selectedDayStart.year, selectedDayStart.month, selectedDayStart.day)).format("YYYY-MM-DD h:mm:ss")
      }
      if (selectedDayEnd !== "") {
         timeStampEnd = Moment(JDate.toGregorian(selectedDayEnd.year, selectedDayEnd.month, selectedDayEnd.day)).format("YYYY-MM-DD h:mm:ss")
      }
      var timeStampDeliveryStart = ""
      var timeStampDeliveryEnd = ""
      if (selectedDayDeliveryStart !== "") {
         timeStampDeliveryStart = Moment(
            JDate.toGregorian(selectedDayDeliveryStart.year, selectedDayDeliveryStart.month, selectedDayDeliveryStart.day)
         ).format("YYYY-MM-DD h:mm:ss")
      }
      if (selectedDayDeliveryEnd !== "") {
         timeStampDeliveryEnd = Moment(
            JDate.toGregorian(selectedDayDeliveryEnd.year, selectedDayDeliveryEnd.month, selectedDayDeliveryEnd.day)
         ).format("YYYY-MM-DD h:mm:ss")
      }

      this.props.props.dispatch({
         type: "WAITSHOW",
      })
      var self = this
      var xhttp = new XMLHttpRequest()
      xhttp.onreadystatechange = function () {
         if (this.readyState === 4 && this.status === 200) {
            var arr = JSON.parse(this.responseText)
            console.log(arr)
            if (arr.result === "ok") {
               self.setState(
                  {
                     requestinfos: arr.data,
                     requestinfofilter: arr.data,
                     arrCount: arr.cnt,
                     credit: arr.credit["remainCredit"] * 100,
                  },
                  () => {}
               )
            } else if (arr.result === "error") {
            }
            self.props.props.dispatch({
               type: "WITEHIDE",
            })
         }
      }
      var fd = new FormData()
      fd.append("command", "getsmsmanage")
      fd.append("limit", rowsPerPage)
      fd.append("offset", page * rowsPerPage)

      fd.append("sms_rahyab_status", smsStatus)
      fd.append("sms_rahyab_receiver", mobileUsertFilter)
      fd.append("sms_rahyab_timestamp_start", timeStampStart)
      fd.append("sms_rahyab_timestamp_end", timeStampEnd)

      fd.append("sms_rahyab_delivery_time_start", timeStampDeliveryStart)
      fd.append("sms_rahyab_delivery_time_end", timeStampDeliveryEnd)

      xhttp.open("POST", `${constants.BASE_URL}/smsmanage`)
      xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      xhttp.send(fd)
   }
   changeStatusSms = () => {
      this.props.props.dispatch({
         type: "WAITSHOW",
      })
      var self = this
      var xhttp = new XMLHttpRequest()
      xhttp.onreadystatechange = function () {
         if (this.readyState === 4 && this.status === 200) {
            var arr = JSON.parse(this.responseText)
            if (arr.result === "ok") {
               self.getOrder()
            } else if (arr.result === "error") {
            }
            self.props.props.dispatch({
               type: "WITEHIDE",
            })
         }
      }
      var fd = new FormData()
      fd.append("command", "getsms_delivery")

      xhttp.open("POST", `${constants.BASE_URL}/smsmanage`)
      xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      xhttp.send(fd)
   }

   createSortHandler = (field) => {
      if (this.state.orderBy === field) {
         if (this.state.order === "asc") {
            this.setState({ order: "desc" })
         } else {
            this.setState({ order: "asc" })
         }
      } else {
         this.setState({ orderBy: field, order: "asc" })
      }
      var arraytemp = [],
         i,
         j,
         temp,
         a,
         b
      arraytemp = this.state.requestinfofilter
      for (i = 0; i < arraytemp.length; i++) {
         for (j = 0; j < arraytemp.length - 1; j++) {
            a = arraytemp[j]
            b = arraytemp[j + 1]
            if (a[field] < b[field] && this.state.order === "asc") {
               temp = arraytemp[j]
               arraytemp[j] = arraytemp[j + 1]
               arraytemp[j + 1] = temp
            } else if (a[field] > b[field] && this.state.order === "desc") {
               temp = arraytemp[j]
               arraytemp[j] = arraytemp[j + 1]
               arraytemp[j + 1] = temp
            }
         }
      }
   }
   handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
         this.getOrder()
      })
   }

   handleChangeFilterMobileAgent = (event) => {
      this.setState({ smsStatus: event.target.value }, () => {
         this.getOrder()
      })
   }

   handleChangeFilterMobileUser = (event) => {
      this.setState({ mobileUsertFilter: event.target.value }, () => {
         this.getOrder()
      })
   }

   handleChangePage = (event, number) => {
      this.setState({ page: parseInt(number, 0) }, () => {
         this.getOrder()
      })
   }

   clearDeyEnd = (event) => {
      this.setState({ selectedDayEnd: "" }, () => {
         this.getOrder()
      })
   }

   setSelectedDayEnd = (event) => {
      this.setState({ selectedDayEnd: event }, () => {
         this.getOrder()
      })
   }

   clearDeyStart = (event) => {
      this.setState({ selectedDayStart: "" }, () => {
         this.getOrder()
      })
   }

   setSelectedDayStart = (event) => {
      this.setState({ selectedDayStart: event }, () => {
         this.getOrder()
      })
   }

   clearDayDeliveryEnd = (event) => {
      this.setState({ selectedDayDeliveryEnd: "" }, () => {
         this.getOrder()
      })
   }

   setSelectedDayDeliveryEnd = (event) => {
      this.setState({ selectedDayDeliveryEnd: event }, () => {
         this.getOrder()
      })
   }

   clearDayDeliveryStart = (event) => {
      this.setState({ selectedDayDeliveryStart: "" }, () => {
         this.getOrder()
      })
   }

   setSelectedDayDeliveryStart = (event) => {
      this.setState({ selectedDayDeliveryStart: event }, () => {
         this.getOrder()
      })
   }

   renderCustomInputEnd = ({ ref }) => (
      <OutlinedInput
         readOnly
         ref={ref} // necessary
         placeholder="انتخاب تاریخ پایان"
         value={
            this.state.selectedDayEnd.year
               ? this.state.selectedDayEnd.year + "/" + this.state.selectedDayEnd.month + "/" + this.state.selectedDayEnd.day
               : ""
         }
         style={{
            fontSize: "13px",
            direction: "ltr",
         }}
         className="my-custom-input-class" // a styling class
         endAdornment={
            <InputAdornment position="end">
               <IconButton onClick={this.clearDeyEnd}>
                  <HighlightOffIcon />
               </IconButton>
            </InputAdornment>
         }
      />
   )

   renderCustomInputStart = ({ ref }) => (
      <OutlinedInput
         readOnly
         ref={ref} // necessary
         placeholder="انتخاب تاریخ شروع"
         style={{
            fontSize: "13px",
            direction: "ltr",
         }}
         value={
            this.state.selectedDayStart.year
               ? this.state.selectedDayStart.year + "/" + this.state.selectedDayStart.month + "/" + this.state.selectedDayStart.day
               : ""
         }
         className="my-custom-input-class" // a styling class
         endAdornment={
            <InputAdornment position="end">
               <IconButton onClick={this.clearDeyStart}>
                  <HighlightOffIcon />
               </IconButton>
            </InputAdornment>
         }
      />
   )

   renderCustomInputDeliveryEnd = ({ ref }) => (
      <OutlinedInput
         readOnly
         ref={ref} // necessary
         placeholder="انتخاب تاریخ پایان"
         value={
            this.state.selectedDayDeliveryEnd.year
               ? this.state.selectedDayDeliveryEnd.year + "/" + this.state.selectedDayDeliveryEnd.month + "/" + this.state.selectedDayDeliveryEnd.day
               : ""
         }
         style={{
            fontSize: "13px",
            direction: "ltr",
         }}
         className="my-custom-input-class" // a styling class
         endAdornment={
            <InputAdornment position="end">
               <IconButton onClick={this.clearDayDeliveryEnd}>
                  <HighlightOffIcon />
               </IconButton>
            </InputAdornment>
         }
      />
   )

   renderCustomInputDeliveryStart = ({ ref }) => (
      <OutlinedInput
         readOnly
         ref={ref} // necessary
         placeholder="انتخاب تاریخ شروع"
         style={{
            fontSize: "13px",
            direction: "ltr",
         }}
         value={
            this.state.selectedDayDeliveryStart.year
               ? this.state.selectedDayDeliveryStart.year +
                 "/" +
                 this.state.selectedDayDeliveryStart.month +
                 "/" +
                 this.state.selectedDayDeliveryStart.day
               : ""
         }
         className="my-custom-input-class" // a styling class
         endAdornment={
            <InputAdornment position="end">
               <IconButton onClick={this.clearDayDeliveryStart}>
                  <HighlightOffIcon />
               </IconButton>
            </InputAdornment>
         }
      />
   )

   render() {
      const { classes } = this.props
      const {
         priceDetail,
         selectedDayDeliveryEnd,
         selectedDayEnd,
         smsStatus,
         mobileUsertFilter,
         selectedDayStart,
         selectedDayDeliveryStart,
         order,
         orderBy,
         okstatus,
         errstr,
         redirect,
         requestinfofilter,
         rowsPerPage,
         page,
         arrCount,
         credit,
      } = this.state
      if (redirect) {
         return <Redirect to="/" />
      } else {
         return (
            <div className={classes.paperrtl} dir="ltr">
               <Grid container spacing={3}>
                  <Grid item xs={12}>
                     <Container maxWidth="lg">
                        <Paper style={{ padding: "15px", direction: "rtl" }} className={classes.root}>
                           <Grid container spacing={3}>
                              <Grid item xs={12}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h6">
                                       {"اعتبار باقی مانده: "}
                                       <NumberFormat displayType={"text"} value={credit} thousandSeparator={true} prefix={" ریال"} />
                                    </Typography>
                                 </div>
                              </Grid>

                              <Grid item xs={6}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h7">
                                       {"تاریخ دلیوری از  "}
                                       <Calendar
                                          renderInput={this.renderCustomInputDeliveryStart} // render a custom input
                                          value={selectedDayDeliveryStart}
                                          onChange={this.setSelectedDayDeliveryStart}
                                          locale="fa"
                                          shouldHighlightWeekends
                                       />
                                    </Typography>
                                 </div>
                              </Grid>
                              <Grid item xs={6}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h7">
                                       {"تاریخ دلیوری تا  "}
                                       <Calendar
                                          renderInput={this.renderCustomInputDeliveryEnd} // render a custom input
                                          value={selectedDayDeliveryEnd}
                                          onChange={this.setSelectedDayDeliveryEnd}
                                          locale="fa"
                                          shouldHighlightWeekends
                                       />
                                    </Typography>
                                 </div>
                              </Grid>
                              <Grid item xs={6}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h7">
                                       {"تاریخ ارسال از  "}
                                       <Calendar
                                          renderInput={this.renderCustomInputStart} // render a custom input
                                          value={selectedDayStart}
                                          onChange={this.setSelectedDayStart}
                                          locale="fa"
                                          shouldHighlightWeekends
                                       />
                                    </Typography>
                                 </div>
                              </Grid>
                              <Grid item xs={6}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h7">
                                       {"تاریخ ارسال تا  "}
                                       <Calendar
                                          renderInput={this.renderCustomInputEnd} // render a custom input
                                          value={selectedDayEnd}
                                          onChange={this.setSelectedDayEnd}
                                          locale="fa"
                                          shouldHighlightWeekends
                                       />
                                    </Typography>
                                 </div>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                 <FloatingLabelInput placeholder=" وضعیت " value={smsStatus} handleInputt={this.handleChangeFilterMobileAgent} />
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                 <FloatingLabelInput
                                    placeholder="همراه کاربر"
                                    value={mobileUsertFilter}
                                    handleInputt={this.handleChangeFilterMobileUser}
                                 />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                 <Button onClick={this.changeStatusSms} variant="contained" color="primary">
                                    {"دریافت وضعیت"}
                                 </Button>
                                 {"    "}
                                 <Button onClick={this.getOrder} variant="contained" color="primary">
                                    {" بروز رسانی لیست"}
                                 </Button>
                              </Grid>
                           </Grid>
                        </Paper>
                     </Container>
                  </Grid>

                  <Grid item xs={12}></Grid>

                  <Grid item xs={12}>
                     <Container maxWidth="lg">
                        <Paper className={classes.root}>
                           <ExcelFile
                              element={
                                 <Button variant="outlined" color="primary">
                                    {" "}
                                    {"اکسل "}
                                 </Button>
                              }>
                              <ExcelSheet data={requestinfofilter} name="نمایندگان">
                                 <ExcelColumn label="آی دی سفارش" value="sms_rahyab_id" />
                                 <ExcelColumn label="رشته بیمه ای" value="request_fieldinsurance_fa" />
                                 <ExcelColumn label="توضیحات" value="request_description" />
                                 <ExcelColumn label="اخرین وضعیت" value="sms_rahyab_status" />
                                 <ExcelColumn label="نام کاربر" value="user_name" />
                                 <ExcelColumn label="نام خانوادگی کاربر" value="user_family" />
                                 <ExcelColumn label="همراه کاربر " value="sms_rahyab_receiver" />
                                 <ExcelColumn label="آی دی" value="agent_id" />
                                 <ExcelColumn label="جنسیت" value="agent_gender" />
                              </ExcelSheet>
                           </ExcelFile>

                           <TableContainer dir="rtl">
                              <Table aria-label="sticky table">
                                 <TableHead>
                                    <TableRow>
                                       <TableCell
                                          key={"sms_rahyab_id"}
                                          align={"center"}
                                          style={{ minWidth: 30 }}
                                          sortDirection={orderBy === "sms_rahyab_id" ? order : false}>
                                          {" شماره سفارش"}
                                          <TableSortLabel
                                             active={orderBy === "sms_rahyab_id"}
                                             direction={orderBy === "sms_rahyab_id" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("sms_rahyab_id")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"sms_rahyab_txt"} align={"center"} style={{ minWidth: 60 }}>
                                          {" متن"}
                                          <TableSortLabel
                                             active={orderBy === "sms_rahyab_txt"}
                                             direction={orderBy === "sms_rahyab_txt" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("sms_rahyab_txt")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"sms_rahyab_receiver"} align={"center"} style={{ minWidth: 60 }}>
                                          {"همراه "}
                                          <TableSortLabel
                                             active={orderBy === "sms_rahyab_receiver"}
                                             direction={orderBy === "sms_rahyab_receiver" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("sms_rahyab_receiver")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"sms_rahyab_status"} align={"center"} style={{ minWidth: 60 }}>
                                          {" وضعیت "}
                                          <TableSortLabel
                                             active={orderBy === "sms_rahyab_status"}
                                             direction={orderBy === "sms_rahyab_status" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("sms_rahyab_status")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"sms_rahyab_timestamp"} align={"center"} style={{ minWidth: 60 }}>
                                          {"تاریخ ارسال"}
                                          <TableSortLabel
                                             active={orderBy === "sms_rahyab_timestamp"}
                                             direction={orderBy === "sms_rahyab_timestamp" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("sms_rahyab_timestamp")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"sms_rahyab_delivery_time"} align={"center"} style={{ minWidth: 60 }}>
                                          {"تاریخ  دلیوری"}
                                          <TableSortLabel
                                             active={orderBy === "sms_rahyab_delivery_time"}
                                             direction={orderBy === "sms_rahyab_delivery_time" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("sms_rahyab_delivery_time")
                                             }}></TableSortLabel>
                                       </TableCell>
                                    </TableRow>
                                 </TableHead>

                                 <TableBody>
                                    {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                       var varmoment = Moment(row["sms_rahyab_timestamp"], "YYYY-M-D HH:mm:ss")
                                       var date = new Date(parseInt(varmoment.format("x")))
                                       var jdate1 = new JDate(date)
                                       var dateMinStr = jdate1.format("YYYY/MM/DD") + "ساعت " + varmoment.format("HH:mm:ss")
                                       var dateMinStr2 = ""
                                       if (row["sms_rahyab_delivery_time"]) {
                                          var varmoment1 = Moment(row["sms_rahyab_delivery_time"], "YYYY-M-D HH:mm:ss")
                                          var date1 = new Date(parseInt(varmoment1.format("x")))
                                          var jdate2 = new JDate(date1)
                                          dateMinStr2 = jdate2.format("YYYY/MM/DD") + "ساعت " + varmoment1.format("HH:mm:ss")
                                       }
                                       return (
                                          <TableRow hover role="checkbox" tabIndex={-1} key={row["sms_rahyab_id"]} value={row}>
                                             <TableCell key={"sms_rahyab_id"} align={"center"}>
                                                {row["sms_rahyab_id"]}
                                             </TableCell>

                                             <TableCell key={"sms_rahyab_txt"} align={"center"}>
                                                {row["sms_rahyab_txt"]}
                                             </TableCell>

                                             <TableCell key={"sms_rahyab_receiver"} align={"center"}>
                                                {row["sms_rahyab_receiver"]}
                                             </TableCell>

                                             <TableCell key={"sms_rahyab_status"} align={"center"}>
                                                {row["sms_rahyab_status"]}
                                             </TableCell>

                                             <TableCell key={"sms_timestamp"} align={"center"}>
                                                {dateMinStr}
                                             </TableCell>

                                             <TableCell key={"sms_timestamp"} align={"center"}>
                                                {dateMinStr2}
                                             </TableCell>
                                          </TableRow>
                                       )
                                    })}
                                 </TableBody>
                              </Table>
                           </TableContainer>
                           <TablePagination
                              rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                              component="div"
                              count={arrCount}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onChangePage={this.handleChangePage}
                              onChangeRowsPerPage={this.handleChangeRowsPerPage}
                           />
                        </Paper>
                     </Container>
                  </Grid>
               </Grid>

               {okstatus ? (
                  <Alert severity="success">
                     <AlertTitle>پیام</AlertTitle>
                     {errstr}
                  </Alert>
               ) : null}
            </div>
         )
      }
   }
}

export default withStyles(styles)(ChangeSmsManage)
